import { BASE_URL } from '../../../shared/consts/variables';

export const login = async (email: string, password: string) => {
    const response = await fetch(`${BASE_URL}/login`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({email, password}),
    });

    const data = await response.json();

    if (!response.ok) {
        const error = new Error(data.message || 'Erro ao fazer login') as Error & {
            status?: number;
            code?: string;
        };

        error.status = response.status;
        error.code = data.code;
        throw error;
    }

    return data;
}
